module.exports = __webpack_public_path__ + "static/img/animales_23.c9a3e036.jpg";